// Imports
import { lighten, saturate } from 'polished';
import { createGlobalStyle } from 'styled-components/macro';
import { GeneratedThemeProps } from './template-style';


// Global styles
const ModernStyle = createGlobalStyle<{ theme: GeneratedThemeProps }>`
	#root, #storybook-root {
		min-height: 100vh;
		font-family: ${(props) => props.theme.fontFamily};
		-webkit-font-smoothing: auto;
		color: ${(props) => props.theme.baseColor};
		background: ${(props) => saturate(0.2, lighten(0.3, props.theme.baseColor))};
		background: linear-gradient(to bottom, ${(props) => saturate(0.2, lighten(0.3, props.theme.baseColor))} 0%, ${(props) =>
			props.theme.baseColor} 31.25rem);
	}
`;

export default ModernStyle;
